module.exports = __webpack_public_path__ + "img/1512801103.70ba2698.jpg";